/**
 * useTheme + useDensity — light wrappers around usePreference that also
 * apply the resolved value to <html> as a class / data attribute.
 *
 * Theme (Q6): toggles `dark` class on <html>; Tailwind's existing
 *   darkMode: 'class' picks it up automatically.
 * Density (Q5): toggles data-dashboards-density="compact|comfortable"
 *   on <html>; dashboards CSS scopes row height / card padding from there.
 */
import { useEffect } from 'react';

import { usePreference } from './usePreference';

export type Density = 'compact' | 'comfortable';
export type Theme = 'light' | 'dark';

export function useTheme() {
  const { value, set } = usePreference<Theme>('dashboards.theme', 'light');
  useEffect(() => {
    const root = document.documentElement;
    if (value === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
  }, [value]);
  return { value, set };
}

export function useDensity() {
  const { value, set } = usePreference<Density>('dashboards.density', 'comfortable');
  useEffect(() => {
    document.documentElement.setAttribute('data-dashboards-density', value);
  }, [value]);
  return { value, set };
}
